export const mockPersonal = [
  {
    id: '1',
    name: 'Carlos Rodríguez',
    position: 'Mesero Senior',
    phone: '+1 4699249598',
    email: 'carlos.rodriguez@eventos.com',
    hireDate: '2022-03-15',
    status: 'active'
  },
  {
    id: '2',
    name: 'María González',
    position: 'Mesera',
    phone: '+1 (555) 234-5678',
    email: 'maria.gonzalez@eventos.com',
    hireDate: '2022-06-20',
    status: 'active'
  },
  {
    id: '3',
    name: 'Juan Martínez',
    position: 'Capitán de Meseros',
    phone: '+1 (555) 345-6789',
    email: 'juan.martinez@eventos.com',
    hireDate: '2021-01-10',
    status: 'active'
  },
  {
    id: '4',
    name: 'Ana López',
    position: 'Mesera',
    phone: '+1 (555) 456-7890',
    email: 'ana.lopez@eventos.com',
    hireDate: '2023-02-14',
    status: 'active'
  },
  {
    id: '5',
    name: 'Pedro Sánchez',
    position: 'Bartender',
    phone: '+1 (555) 567-8901',
    email: 'pedro.sanchez@eventos.com',
    hireDate: '2022-09-05',
    status: 'active'
  },
  {
    id: '6',
    name: 'Laura Fernández',
    position: 'Mesera Senior',
    phone: '+1 (555) 678-9012',
    email: 'laura.fernandez@eventos.com',
    hireDate: '2021-11-22',
    status: 'active'
  },
  {
    id: '7',
    name: 'Roberto Torres',
    position: 'Mesero',
    phone: '+1 (555) 789-0123',
    email: 'roberto.torres@eventos.com',
    hireDate: '2023-04-18',
    status: 'active'
  },
  {
    id: '8',
    name: 'Carmen Ruiz',
    position: 'Chef',
    phone: '+1 (555) 890-1234',
    email: 'carmen.ruiz@eventos.com',
    hireDate: '2020-08-30',
    status: 'active'
  }
];
